
    <p class="m-0 s-14 font-weight-600">{{ location.name }}</p>
    {{ location.address.formattedAddress }}<br>
    <b class="link" (click)="openDialog(location)">Ver mais</b>
  